import React from 'react';

const CarLoan = () => (
  <div style={{padding:32}}>
    <h2>Зээлийн үйлчилгээ</h2>
    <div>Таны автомашины зээлийн үйлчилгээний мэдээлэл энд харагдана.</div>
    {/* TODO: Бодит өгөгдөлтэй холбох, backend API шаардлагатай бол үүсгэнэ */}
  </div>
);

export default CarLoan;
